<template>
  <modal-padrao
    ref="modal"
    max-width="900px"
    :titulo="$t('modulos.calibracao.valores.titulos.depuracao_modal')"
    :mostra-botao-salvar="false"
  >
    <div ref="printSection">
      <img
        class="imprimir header-img"
        src="@/assets/img/logoKeL.png"
        alt=""
      >
      <h3
        class="header-h3 imprimir"
      >
        {{ $t('modulos.calibracao.impressao.titulo') }}
      </h3>
      <div class="print-header">
        <p><strong>{{ $t('modulos.calibracao.impressao.codigo') }}:</strong> {{obterValorPorCabecalhoEChave(logs, "Instrumento", "Código")}}</p>
        <p><strong>{{ $t('modulos.calibracao.impressao.instrumento') }}:</strong> {{obterValorPorCabecalhoEChave(logs, "Instrumento", "Tipo do Instrumento")}}</p>
        <p><strong>{{ $t('modulos.calibracao.impressao.tipo') }}:</strong> {{obterValorPorCabecalhoEChaveAninhado(logs, "Variáveis", "x", "instrumentoPadrao.codigo")}} </p>
        <p><strong>{{ $t('modulos.calibracao.impressao.ordem_servico') }}:</strong> {{ obterValorPorCabecalhoEChaveAninhado(logs, "Variáveis", "x", "instrumentoPadrao.ultimoCertificado.codigo") }}</p>
        <p><strong>{{ $t('modulos.calibracao.impressao.cliente') }}:</strong> {{ obterValorPorCabecalhoEChaveAninhado(logs, "Variáveis", "escopo", "nome") }}</p>
        <p><strong>{{ $t('modulos.calibracao.impressao.tipo_calibracao') }}:</strong> {{ tipoCalibracaoItem?.nome }}</p>
        <p><strong>{{ $t('modulos.calibracao.impressao.situacao_certificado') }}:</strong> {{ situacaoCertificado }}</p>
      </div>
      <v-simple-table>
        <tbody>
          <tr style="background: #f2f4f7">
            <td style="width: 250px">
              <div class="d-flex align-center">
                <botao-padrao
                  class="mr-2 nao-imprimir"
                  color="secondary"
                  text
                  @click="alternarExpandirTodos"
                >
                  <v-icon>{{ expandidoTodos ? '$upArrow' : '$downArrow' }}</v-icon>
                </botao-padrao>
                <span>
                  {{ $t('modulos.calibracao.valores.titulos.variavel') }}
                </span>
              </div>
            </td>
            <td>{{ $t('modulos.calibracao.valores.titulos.valor') }}</td>
          </tr>
        </tbody>
        <tbody
          v-for="(log, i) in logs"
          :key="i"
        >
          <tr>
            <td
              class="cabecalho"
              colspan="2"
            >
              <div class="d-flex align-center">
                <botao-padrao
                  class="nao-imprimir mr-2"
                  color="secondary"
                  text
                  @click="log.expandido = !log.expandido"
                >
                  <v-icon>{{ log.expandido ? '$upArrow' : '$downArrow' }}</v-icon>
                </botao-padrao>
                <span>
                  {{ log.cabecalho }}
                </span>
              </div>
            </td>
          </tr>
          <template v-if="log.expandido">
            <tr
              v-for="(detalhe, j) in log.detalhes"
              :key="j"
              :class="detalhe.chave == 'variável não encontrada' ? 'erro' : ''"
            >
              <td
                style="width: 250px"
                class="pl-7"
              >
                {{ detalhe.chave }}
              </td>
              <td>
                <pre class="imprimir">{{ detalhe.valor }}</pre>
                <vue-json-pretty
                  class="json-pretty"
                  :show-icon="true"
                  :data="detalhe.valor"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </div>
    <template #botaoAdicional>
      <botao-padrao
        class="ui primary button botao-padrao"
        type="button"
        @click="imprimeModal()"
      >
        Imprimir
      </botao-padrao>
    </template>
  </modal-padrao>
</template>
<script>
import CalibracaoService from '@common/services/cadastros/CalibracaoService';
import VueJsonPretty from 'vue-json-pretty';
import helpers from '@common/utils/helpers';
import 'vue-json-pretty/lib/styles.css';
import { mapGetters } from 'vuex';
import EnumeradorService from '@common/services/cadastros/EnumeradorService';
import SituacaoCertificadoEnum from '@/common/enum/enumeradores/SituacaoCertificadoEnum';

export default {
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      logs: [],
      situacaoCertificado: ""
    };
  },
  props: [
    'tipoCalibracaoId',
    'opcoes'
  ],
  computed: {
    ...mapGetters('calibracao', ['getTiposCertificado', 'getTotalItems', 'getItensCertificado', "getItemById"]),
    tipoCalibracaoItem() {
      return this.getItemById(this.tipoCalibracaoId);
    },
    expandidoTodos : function(){
      return this.logs.every(el => el.expandido);
    }
  },
  watch: {
    opcoes: {
      handler(newValue) {
        if(newValue?.situacaoCertificado){
          const status = SituacaoCertificadoEnum.find(status => status.value === this.opcoes.situacaoCertificado);
          this.situacaoCertificado = status?.text;
        }       
      },
      deep: true
    }
  },
  mounted(){
  },
  methods: {
    async imprimeModal() {
      await this.expandirTodos()
      const printSectionHtml = this.$refs.printSection;
      const titulo = this.$t('modulos.calibracao.depuracao.depuracao_valores_calculo');
      const optionsCss = 
      `@media print {
        @import 'vue-json-pretty/lib/styles.css';
          .nao-imprimir{
            display: none;
          }
          .imprimir{
            font-size: 14px; white-space: pre-wrap; width: calc(100vw - 300px);
          }
          .json-pretty{
            display: none; font-size: 14px; white-space: pre-wrap; width: calc(100vw - 300px);
          }
          h3{
            color: blue;
          }
        }
        
        .print{
          width: 100vw - 300px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid #dddddd;
          padding: 8px;
          text-align: left;
        }

        .titulo-pagina {
          margin-bottom: 6px;
        }

        body { 
          font-family: Arial, sans-serif; 
        }

        .printable-content { 
          width: 100%; 
        }

        pre {
          white-space: pre-wrap;
          word-wrap: break-word;
        }

        h3 {
          color: black
        }
          
        p {
          margin: 0;
          padding: 0;
          line-height: 1.2;
        }

        .header-h3 {
          text-align: center;
          width: 100%
        }
        
        .print-header{
          border-top: 4px solid #34507b; 
          border-bottom: 4px solid #34507b; 
          padding: 10px;
          margin-bottom: 10px;
          margin-top: 0px;
        }

        .header-img {
          width: 140px;
        }        
        `;
      helpers.printContent({printSectionHtml: printSectionHtml.innerHTML, optionsCss, titulo});
      this.alternarExpandirTodos()
    },
    buscarEnumerador: function (nomeEnumerador, variavelOptions) {
      EnumeradorService.buscar(nomeEnumerador).then((res) => {
        this.opcoes[variavelOptions] = res;
      });
    },
    abrirModal: function (calibracaoId, linha) {
      this.$store.dispatch('Layout/iniciarCarregamento');
      CalibracaoService.calcularLinha(calibracaoId, linha.id, linha, true)
        .then((res) => {
          this.logs = res.data.logs.map((el) => {
            el.expandido = false;
            el.detalhes = el.detalhes.map((detalhe) => {
              try {
                detalhe.valor = JSON.parse(detalhe.valor);
                detalhe.json = true;
              } catch (e) {
                detalhe.json = false;
              }
              return detalhe;
            });
            return el;
          });
          this.$refs.modal.abrirModal();
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    expandirTodos: async function() {
      this.logs = this.logs.map(el => {
        el.expandido = true;
        return el;
      });
    },
    alternarExpandirTodos : async function(){
      let expandir = !this.logs.every(el => el.expandido);
      this.logs = this.logs.map(el => {
        el.expandido = expandir;
        return el
      })
    },
    obterValorPorCabecalhoEChaveAninhado(jsonData, cabecalhoBusca, chaveBusca, caminhoValor) {
      // Percorre o array de objetos no JSON
      for (let item of jsonData) {
          // Verifica se o cabeçalho corresponde ao cabecalhoBusca
          if (item.cabecalho === cabecalhoBusca) {
              // Percorre os detalhes deste item para encontrar a chave
              for (let detalhe of item.detalhes) {
                  if (detalhe.chave === chaveBusca && detalhe.json === true) {
                      // Se o valor for um objeto JSON, percorre o caminho fornecido para acessar o valor aninhado
                      let valor = detalhe.valor;
                      for (let caminho of caminhoValor.split('.')) {
                          valor = valor[caminho];
                          if (valor === undefined) {
                              return null; // Retorna null se o caminho for inválido
                          }
                      }
                      return valor;
                  }
              }
          }
      }
      return null; // Retorna null se não encontrar o valor
  },
    obterValorPorCabecalhoEChave(jsonData, cabecalhoBusca, chaveBusca) {
        // Percorre o array de objetos no JSON
        for (let item of jsonData) {
            // Verifica se o cabeçalho corresponde ao cabecalhoBusca
            if (item.cabecalho === cabecalhoBusca) {
                // Percorre os detalhes deste item para encontrar a chave
                for (let detalhe of item.detalhes) {
                    if (detalhe.chave === chaveBusca) {
                        // Retorna o valor correspondente à chave
                        return detalhe.valor;
                    }
                }
            }
        }
        // Retorna null se não encontrar o valor
        return null;
    }
  },
};
</script>
<style>
td.cabecalho {
  border-bottom: 2px solid #e4e7ec;
}
tr:nth-child(even) {
  background: #f9fafb;
}
tr.erro {
  background: rgb(242, 190, 190);
}
tr.erro .vjs-value-string {
  color: #f00;
  font-weight: 700;
}
.imprimir{
  display: none;
}
.print-header p{
  margin-bottom: 0px;
}
.print-header{
  border-top: 4px solid #34507b; 
  border-bottom: 4px solid #34507b; 
  padding: 10px;
  margin-bottom: 10px;
  display: none;
}
</style>
